import {EditPermissions} from '../../../../../../../shared/models';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {getEditTypes} from '../../../delegatorUtils';
import {required} from '../../../../../../../shared/utils';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';

type AIInferenceType = 'assistant' | 'context_router';

interface AiAssistantData {
    name: string;
    text: string;
    initPrompt: string;
    inferenceType: AIInferenceType;
    assistantId: string;
    enableRoutingMessage: boolean;
    successNext: string;
    successDescription: string;
    errorNext: string;
    errorDescription: string;

}

export const NODE_TYPE = 'aiAssistant';

export class AiAssistantNode {

    private menu: {} = {};

    constructor() {
        this.menu = {
            'menuType': NODE_TYPE,
        };
    }

    public static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        const formData: AiAssistantData = this.getFromData(stepData);

        return this.buildForm(formData, editFlows);
    }

    private static getFromData(stepData: { [index: string]: any }): AiAssistantData {

        const menu = stepData?.menu ? stepData?.menu : {};
        const menuParams = menu?.menuParams ? menu?.menuParams : {};
        const results = menu?.results ? menu?.results : {};

        const success = results?.success ? results?.success : {};
        const error = results?.error ? results?.error : {};

        return {
            text: menu?.text ? menu?.text : '',
            name: menu?.name ? menu?.name : '',
            initPrompt: menuParams?.initPrompt ? menuParams?.initPrompt : '',
            inferenceType: menuParams?.inferenceType ? menuParams?.inferenceType : 'assistant',
            assistantId: menuParams?.assistantId ? menuParams?.assistantId : '',
            enableRoutingMessage: menuParams?.enableRoutingMessage != null ? menuParams?.enableRoutingMessage : true,
            successNext: success?.next ? success?.next : newStepValue,
            successDescription: success?.description ? success?.description : 'Go to next step',
            errorNext: error?.next ? error?.next : newStepValue,
            errorDescription: error?.description ? error?.description : 'Unable to connect to AI Assistant',
        };
    }

    private static buildForm(formData: AiAssistantData, editFlows: boolean): UntypedFormGroup {
        return new UntypedFormGroup({
            name: new UntypedFormControl({
                value: formData.name,
                disabled: !editFlows
            }, required('Name')),
            text: new UntypedFormControl({
                value: formData.text,
                disabled: !editFlows
            }),
            initPrompt: new UntypedFormControl({
                value: formData.initPrompt,
                disabled: !editFlows
            }),
            inferenceType: new UntypedFormControl({
                value: formData.inferenceType,
                disabled: !editFlows
            }),
            assistantId: new UntypedFormControl({
                value: formData.assistantId,
                disabled: !editFlows
            }, required('Assistant')),
            enableRoutingMessage: new UntypedFormControl({
                value: formData.enableRoutingMessage,
                disabled: !editFlows
            }),
            successNext: new UntypedFormControl({
                value: formData.successNext,
                disabled: !editFlows
            }),
            successDescription: new UntypedFormControl({
                value: formData.successDescription,
                disabled: !editFlows
            }, required('Description')),
            errorNext: new UntypedFormControl({
                value: formData.errorNext,
                disabled: !editFlows
            }),
            errorDescription: new UntypedFormControl({
                value: formData.errorDescription,
                disabled: !editFlows
            }, required('Description')),
        });
    }

    setNodeData(nodeData: AiAssistantData) {

        const {
            assistantId,
            errorDescription,
            successDescription,
            successNext,
            errorNext,
            name,
            inferenceType,
            text,
            initPrompt,
            enableRoutingMessage
        } = nodeData;

        const menuParams = {
            inferenceType
        };

        if (inferenceType === 'assistant') {
            menuParams['assistantId'] = assistantId;
        }

        if (inferenceType === 'context_router') {
            menuParams['enableRoutingMessage'] = enableRoutingMessage;
        }

        if (initPrompt) {
            menuParams['initPrompt'] = initPrompt;
        }

        const results = {
            success: {
                next: successNext,
                description: successDescription
            },
            error: {
                next: errorNext,
                description: errorDescription
            }
        };


        this.menu = {
            ...this.menu,
            text,
            name,
            menuParams,
            results
        };
    }

    get nodeData(): {} {
        return {
            menu: this.menu,
            'type': 'menu',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }
}


